<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "AppRoot",
};
</script>

<style>
html,
body,
#app {
  min-height: 100%;
}

body {
  margin: 0;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  font-family: "Microsoft YaHei", "PingFang SC", sans-serif;
}
</style>
